import MouseFollower from "./MouseFollower";

export default MouseFollower;
